import { Record } from "immutable";

import { ServiceLocationState } from "@typings/serviceLocation";

export const LOCAL_STORAGE_KEY = "store:serviceLocation";

export type ServiceLocationReducer = Record<ServiceLocationState>;

export interface ServiceLocationParams {
  saveData?: boolean;
}
